import React from 'react'
import SingleAchievement from '../homescreen/SingleAchievement'
import { ReactComponent as ArchiveIcon } from '../../svg/achievements/ArchiveIcon.svg'
import { useTranslation } from 'react-i18next'

function OurAchievements() {
    const { t } = useTranslation()
    return (
        <div className="achievements-center-body-left">
            <div className="achievements-center-body-selection">
                <div className="achievements-center-body-selection-text">{t('Our Achievements')}</div>
                <div className="achievements-center-body-selection-archive-container">
                    <ArchiveIcon />
                    <div className="achievements-center-body-selection-archive">{t('archive')}</div>
                </div>
            </div>
            <div className="achievements-center-body-selection-subtext">{t('Boost your points by earning achievements')}</div>
            <div className="achievements-center-body-daily">
                <div className="achievements-center-body-daily-title">
                    <div className="achievements-center-body-daily-title-text">{t('Daily Achievements')}</div>
                    <div className="achievements-center-body-daily-title-dashes"></div>
                </div>
                <div className="achievements-center-body-list-container">
                    <div className="achievements-center-body-list-container-scroll blue-small-scroll">
                        {['a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9'].map((achievement, index) => {
                            return (
                                <div style={{ marginBottom: 10 }} key={index}>
                                    <SingleAchievement item={achievement} width={238} />
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            <div className="achievements-center-body-daily">
                <div className="achievements-center-body-daily-title">
                    <div className="achievements-center-body-daily-title-text">{t('Features achievements')}</div>
                    <div className="achievements-center-body-daily-title-dashes"></div>
                </div>
                <div className="achievements-center-body-list-container">
                    <div className="achievements-center-body-list-container-scroll blue-small-scroll">
                        {['a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9'].map((achievement, index) => {
                            return (
                                <div style={{ marginBottom: 10 }} key={index}>
                                    <SingleAchievement item={achievement} width={238} />
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OurAchievements
